<template>
  <section>
    <el-row  style="min-width:1100px;padding:15px;margin-bottom:30px">
      <el-col :span="24">
      	<el-button size="medium" type="primary" @click="goBack">返回</el-button>
       <!-- <el-button type="text" >{{typename}}</el-button>-->
      </el-col>
     
    </el-row>
		
		<el-row>
			 <el-table :data="plog">
			 	<el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        
        
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
      
      <!--<div class="pageRow">
	    <el-pagination
	      class="pagination"
	      @size-change="SizeChange"
	      @current-change="CurrentChange"
	      :current-page.sync="pdata.page"
	      :page-sizes="[20, 40, 60, 80]"
	      :page-size="pdata.perpage"
	      background
	      layout="sizes, prev, pager, next, jumper"
	      :total="pdata.perpage*maxPage"
	    ></el-pagination>
    </div>-->
		</el-row>
		

  </section>
</template>
<script>
import { sclog, } from "../../api/api";
export default {
  data() {
    return {
      plog: [],
     	pdata: {
     		index_id:"",
        page: 1,
        perpage: 100,
        status: "",
        kw: "",
        sort_field: "",
        sort_by: ""
      },
      type:'',
      typename:'',
      maxPage: 1,
    };
  },
  methods: {
  	goBack(){
			this.$router.go(-1);
		},
    openDealy(id) {
  	 	var p = '&type='+this.type+'&';
  	 	 for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      sclog(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
          this.maxPage = res.data.max_page;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    
    log(t) {
      this.$alert(t, "更新日志");
    },
		SizeChange(v) {
      this.pdata.perpage = v;
      this.openDealy();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.openDealy();
    },


  },
  mounted() {
  	this.pdata.index_id = this.$route.params.index_id;
  	this.type= this.$route.query.type;
  
  	this.typename = this.$route.name;
    this.openDealy('');
  }
};
</script>
<style>
.el-timeline{
  width: 500px;
}
</style>




// WEBPACK FOOTER //
// productLog.vue?5ed89ce8